import { useAccountDataQuery } from 'queries/account';
export const useIsRmAgentEnabled = ()=>{
    var _ref;
    var _data_accountMeta_features, _data_accountMeta;
    const { data } = useAccountDataQuery();
    return (_ref = data === null || data === void 0 ? void 0 : (_data_accountMeta = data.accountMeta) === null || _data_accountMeta === void 0 ? void 0 : (_data_accountMeta_features = _data_accountMeta.features) === null || _data_accountMeta_features === void 0 ? void 0 : _data_accountMeta_features.rmAgent) !== null && _ref !== void 0 ? _ref : false;
};
